import * as actionType from "../constants";
export const addReasonRowUpdate =
  (input, any = null) =>
  (dispatch) => {
    if (any == "status") {
      return input;
    }
    dispatch({ type: actionType.ADD_REASON_ROW_UPDATE, payload: input });
  };
